// Postup – časová osa se plní podle scrollu
(() => {
    const timeline = document.querySelector(".JS-timeline");

    if (timeline && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        const steps = timeline.querySelectorAll(".JS-timeline-step");
        let ticking = false;

        const update = () => {
            const rect = timeline.getBoundingClientRect();
            const anchor = window.innerHeight * 0.6;
            const progress = Math.min(Math.max((anchor - rect.top) / rect.height, 0), 1);
            timeline.style.setProperty("--progress", progress.toFixed(3));

            steps.forEach((step) => {
                const node = step.querySelector(".node").getBoundingClientRect();
                step.classList.toggle("is-done", node.top + node.height / 2 < anchor);
            });
            ticking = false;
        };

        window.addEventListener("scroll", () => {
            if (!ticking) {
                requestAnimationFrame(update);
                ticking = true;
            }
        }, { passive: true });

        update();
    }
})();
